import { Component } from "react";

class FacebookSDK extends Component {
  componentDidUpdate() {
    this.parseXFBML();
  }

  parseXFBML() {
    if (typeof window !== `undefined` && {}.hasOwnProperty.call(window, "FB")) {
      // Get all the divs with a Facebook plugin
      // Convert the NodeList to an array
      const plugins = [].slice.call(document.querySelectorAll(".fb-plugin"));

      // Use the FB SDK to parse each opf the plugins
      plugins.map(plugin => window.FB.XFBML.parse(plugin));
    }
  }

  render() {
    return null;
  }
}

export default FacebookSDK;



// WEBPACK FOOTER //
// ./src/components/FacebookSDK/FacebookSDK.jsx